export default __webpack_public_path__ + "static/media/DSC_5942-min.3fb06a74.JPG";